<mat-menu #appMenu="matMenu">
  <button mat-menu-item [disabled]="isAppointmentDetailsDisabled" [routerLink]="['/appointment-details', appointment.EventID]">{{ 'MENU.APPOINTMENT-DETAILS' | translate }}</button>
  <button mat-menu-item (click)="onMove()" [disabled]="!canBeMoved">{{ 'MENU.MOVE-APPOINTMENT' | translate }}</button>
  <button mat-menu-item (click)="onDelete()"  [disabled]="!canBeDeleted">{{ 'MENU.DELETE-APPOINTMENT' | translate }}</button> 
  <!-- <button mat-menu-item  [routerLink]="['/standby', appointment.EventID]">{{ 'MENU.STANDBY' | translate }}</button> -->
  <button mat-menu-item (click)="onStandBy()" [disabled]="!canBeMovedToWaitList">{{ 'MENU.STANDBY' | translate }}</button>
  <button mat-menu-item (click)="onConfirm()" [disabled]="!canBeMarkedHasApproved">{{ 'MENU.APPOINTMENT-APPROVED' | translate }}</button>
  <button mat-menu-item (click)="onFutureVisits()">{{ 'MENU.APPOINTMENT-HISTORY' | translate }}</button> 
  <button mat-menu-item (click)="onPatientDetails()" [disabled]="!canEnterPatientDetails">{{ 'MENU.PATIENT-DETAILS' | translate }}</button>
  <button mat-menu-item [matMenuTriggerFor]="captureImage" (click)="onCaptureImage()" [disabled]="!canCaptureImage">{{ 'MENU.CAMERA' | translate }}</button>
  <button mat-menu-item (click)="onUploadDocument()" [disabled]="!canUploadDocument">{{ 'MENU.FILE' | translate }}</button>

  <!-- only in staging-->
  <button mat-menu-item [matMenuTriggerFor]="paymentrequest">{{ 'MENU.PAYMENT-REQUEST' | translate }}</button>

  <button mat-menu-item (click)="onSendOrFillForm()" [disabled]="!canSendOrFillForm">{{ 'MENU.SEND-OR-FILL-FORM' | translate }}</button>
</mat-menu>

<mat-menu #paymentrequest="matMenu">
  <button mat-menu-item (click)="onPaymentRequest('pelecard')" [disabled]="!canMakePaymentRequestInPelecard">{{ 'MENU.PELECARD' | translate}}</button>
  <button mat-menu-item (click)="onPaymentRequest('bit')" [disabled]="!canMakePaymentRequestInBit">{{ 'MENU.BIT' | translate}}</button>  
</mat-menu>

<mat-menu #captureImage="matMenu">
  <button mat-menu-item (click)="onCaptureImage()" [disabled]="!canCaptureImage">{{ 'MENU.PICTURE' | translate}}</button>
  <button mat-menu-item (click)="onCaptureProfileImage()" [disabled]="!canCaptureImage">{{ 'MENU.PATIENT-PICTURE' | translate}}</button>  
</mat-menu>

<button mat-icon-button [matMenuTriggerFor]="appMenu" class="p-0 m-0" *ngIf="appointment">
  <mat-icon>more_vert</mat-icon>
</button>
